import { Text } from "@chakra-ui/react";
import React from "react";
import Card from "../Card";

type TestimonialProps = {};
const Testimonial: React.FC<TestimonialProps> = () => {
  return (
    <Card
      w="50%"
      h="70%"
      direction="column"
      justify="space-evenly"
      align="center"
      fontSize="lg"
      bg="white"
      color="black"
    >
      <Text w="80%" align="center" fontFamily="Verdana">
        "I have had the pleasure of working with this company for the last 6
        years. The benefit of HRBEE is that not only do they have an acute
        understanding of the BEE landscape and all legislation behind it, they
        also learn your business and help find ways in which BEE becomes far
        more than just a scorecard but a meaningful part of your business. It is
        for this reason that I certainly recommend the use of the HRBEE team for
        the purpose of assistance in this sphere."
      </Text>
      <Text
        fontWeight="bold"
        fontStyle="italic"
        fontFamily="sans-serif"
        alignSelf="left"
      >
        - Paul Levine, CEO of Aquazania
      </Text>
    </Card>
  );
};

export default Testimonial;
